define('v3/Common/Components/ModalCarouselNavigationButtons/LazyLoadItemContentAdapter',[
	'knockout'
], function (ko) {
	function LazyLoadItemContentAdapter (item, index) {
		var self = this;

		self.item = item;
		self.index = index;
		self.content = ko.pureComputed(function () {
			return self.item() ? self.item().content() : null;
		});

		self.dispose = function () {
			if (self.content) self.content.dispose();
		};
	}

	return LazyLoadItemContentAdapter;
});
